// import * as MessageActions from '../../common/messageBox/actions/actions';
import * as ActionTypes from './actionTypes';
import apiActionCreator from '../../common/service/api/actionCreator';
import {buildErrorMessage, buildSuccessMessage} from '../../common/util/errorUtils';
import {getUrlParameters} from '../../common/util/urlParameters';
import {navigateTo} from '../../router/actions';

export const fetchComboDetail = (code) => apiActionCreator({
  'endpoint': `/sets/${code}`,
  'authenticated': true,
  'types': [
    ActionTypes.FETCHING_COMBO_DETAIL,
    ActionTypes.FETCHED_COMBO_DETAIL,
    [
      ActionTypes.FETCHED_COMBO_DETAIL_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});

export const fetchAccessoriesList = (params) => apiActionCreator({
  'endpoint': `/sets/parts${getUrlParameters(params)}`,
  'authenticated': true,
  'types': [
    ActionTypes.FETCHING_ACCESSORIES_LIST,
    ActionTypes.FETCHED_ACCESSORIES_LIST,
    [
      ActionTypes.FETCHED_ACCESSORIES_LIST_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});

export const fetchVehiclesModelsList = (combo = false) => apiActionCreator({
  'endpoint': `/sets/models${combo ? '?combo=YES' : ''}`,
  'authenticated': true,
  'types': [
    ActionTypes.FETCHING_VEHICLES_MODELS_LIST,
    ActionTypes.FETCHED_VEHICLES_MODELS_LIST,
    [
      ActionTypes.FETCHED_VEHICLES_MODELS_LIST_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});

export const fetchDealersList = () => apiActionCreator({
  'endpoint': '/sets/dealers',
  'authenticated': true,
  'types': [
    ActionTypes.FETCHING_DEALERS_LIST,
    ActionTypes.FETCHED_DEALERS_LIST,
    [
      ActionTypes.FETCHED_DEALERS_LIST_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});

export const cleanAccessoriesList = () => ({
  'type': ActionTypes.CLEAN_ACCESSORIES_LIST,
});

export const cleanVehiclesModelsList = () => ({
  'type': ActionTypes.CLEAN_VEHICLES_MODELS_LIST,
});

export const updateCombo = (data, code = null, action = null) => (dispatch) => {
  return dispatch(
    apiActionCreator({
      'endpoint': `/sets/${code}`,
      'authenticated': true,
      'types': [
        ActionTypes.UPDATING_COMBO,
        [
          {
            'type': ActionTypes.UPDATED_COMBO,
          },
          (response) => {
            dispatch(buildSuccessMessage(response, `Combo ${code ? 'modificado' : 'creado'} satisfactoriamente`));
            if (!action) {
              dispatch(navigateTo(`/combos/editar/${response.data.code}`));
            }
          },
        ],
        [
          ActionTypes.UPDATED_COMBO_FAILED,
          (error) => buildErrorMessage(error),
        ],
      ],
      'contentType': 'application/json',
      'data': data,
      'microservice': 'part',
      'method': 'PUT',
    })
  );
};

export const createCombo = (data) => (dispatch) => {
  dispatch(updateCombo(data, data.data.code, 'CREATE'));
};

export const addComboToModel = (sfx, katashiki, combo) => apiActionCreator({
  'endpoint': `/sets/model-combo-transaction/${sfx}/${katashiki}/${combo}`,
  'authenticated': true,
  'types': [
    ActionTypes.ADDING_COMBO_TO_MODEL,
    [
      (response) => {
        return {
          'type': ActionTypes.ADDED_COMBO_TO_MODEL,
          'payload': {
            'data': response.data,
            'combo': combo,
          },
        };
      },
    ],
    [
      ActionTypes.ADDED_COMBO_TO_MODEL_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'POST',
});

export const deleteComboFromModel = (sfx, katashiki, combo) => apiActionCreator({
  'endpoint': `/sets/model-combo-transaction/${sfx}/${katashiki}/${combo}`,
  'authenticated': true,
  'types': [
    ActionTypes.DELETING_COMBO_TO_MODEL,
    [
      (response) => {
        return {
          'type': ActionTypes.DELETED_COMBO_TO_MODEL,
          'payload': {
            'data': response.data,
            'combo': combo,
          },
        };
      },
    ],
    [
      ActionTypes.DELETED_COMBO_TO_MODEL_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'DELETE',
});
